import { sendAnalyticsEvent } from '@faststore/sdk'
import { useCallback } from 'react'
import type { PromoView } from 'src/sdk/analytics'

export type Promo =
  | Array<{
      id: string
      name: string
      creative: string
      position: string | number | null
      index?: number
    }>
  | string

/**
 * @export
 * @description send event promoView
 * @param {string} alt indentifier to params
 * @param {string} page indentifier of position
 * @returns void
 */

export const useEventPromoView = (uuid: string | null, ...args: Promo[]) => {
  const sendPromoView = useCallback(() => {
    if (typeof args?.[0] === 'string') {
      return
    }

    const promoParams = args?.[0]?.map((promo) => ({
      ...promo,
      uuid,
    }))

    sendAnalyticsEvent<PromoView>({
      name: 'promo_view',
      params: promoParams,
    })
  }, [args, uuid])

  return { sendPromoView }
}
